/**
 * Zentrale Hilfsfunktionen für Formatierung (de-DE).
 * Nutzen: einheitliche Anzeige und Korrekturen (z. B. kaputte Umlaute) in der gesamten App.
 */

/**
 * Versucht typische UTF‑8/Latin‑1-Kodierungsfehler bei Umlauten zu korrigieren,
 * wie sie häufig aus externen Datenquellen kommen (z. B. "MÃ¤rklin" → "Märklin").
 */
export function normalizeUmlauts(value: unknown): string {
  if (value == null) return "";
  let str = String(value);

  // Häufigste UTF‑8/Latin‑1-Mojibake für deutsche Umlaute und ß
  str = str
    .replace(/Ã„/g, "Ä")
    .replace(/Ã¤/g, "ä")
    .replace(/Ã–/g, "Ö")
    .replace(/Ã¶/g, "ö")
    .replace(/Ãœ/g, "Ü")
    .replace(/Ã¼/g, "ü")
    .replace(/ÃŸ/g, "ß");

  return str;
}

/** Datum + Uhrzeit, z. B. "04.02.2025, 14:30" */
export function formatDateTime(value: string | number | Date | null | undefined): string {
  if (value == null) return "–";
  try {
    const d = typeof value === "object" && "getTime" in value ? value : new Date(value);
    if (isNaN(d.getTime())) return "–";
    return d.toLocaleString("de-DE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "–";
  }
}

/** Nur Datum, z. B. "04.02.2025" */
export function formatDate(value: string | number | Date | null | undefined): string {
  if (value == null) return "–";
  try {
    const d = typeof value === "object" && "getTime" in value ? value : new Date(value);
    if (isNaN(d.getTime())) return "–";
    return d.toLocaleDateString("de-DE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  } catch {
    return "–";
  }
}

/** Kurzes Datum ohne Jahr, z. B. "04.02." */
export function formatDateShort(value: string | number | Date | null | undefined): string {
  if (value == null) return "–";
  try {
    const d = typeof value === "object" && "getTime" in value ? value : new Date(value);
    if (isNaN(d.getTime())) return "–";
    return d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit" });
  } catch {
    return "–";
  }
}
